<template>
  <div class="my-trips py-60">
    <div class="container p-15">
      <div class="row p-15 mb-30">
        <div class="col-md-9">
          <h1>My Trips: </h1>
        </div>
        <div class="col-md-3 text-right">
          <router-link class="btn btn-success" to="/trip/create">Create New Trip</router-link>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-4 col-md-6 col-sm-12" v-for="trip in trips" :key="trip.id">
          <trip-list-item :trip="trip" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import httpClient from '@/utils/httpClient';
  import TripListItem from '@/components/Trip/TripListItem'

export default {
  components: {
    TripListItem
  },
  data () {
    return {
      trips: []
    }
  },
  mounted () {
    this.fetchTrips()
  },
  methods: {
    fetchTrips() {
      httpClient.get("/api/user_trips").then(res => {
        this.trips = res.data.trips
      });	
    }
  }
}
</script>

<style>
.my-trips .container {
  width: 90%;
	padding-right: 15px;
	padding-left: 15px;
	margin-right: auto;
	margin-left: auto;
}
@media (min-width: 576px) {
	.my-trips .container {
		max-width: 100%;
	}
}
@media (min-width: 576px) {
	.my-trips .container {
		max-width: 540px;
	}
}
@media (min-width: 768px) {
	.my-trips .container {
		max-width: 720px;
	}
}
@media (min-width: 1200px) {
	.my-trips .container {
		max-width: 1140px;
	}
}
</style>